import React, { FC, useMemo } from "react";
import { Column } from "../../../../../types/column";
import { get } from "lodash";
import "./cell.scss";
import mixin from "../../../../../mixin/convert-number";

type Row = {
  id: number;
  name: string;
  [key: string]: any;
};

interface Prop {
  row: Row;
  column: Column;
  index: number;
}

const StringCell: FC<Prop> = ({ row, column, index }) => {
  const value = useMemo(() => {
    const fromProp = get(row, column.prop, "");
    const postfix = get(column, "postfix", "");
    let value = get(row, column.display as string, fromProp);
    value =
      column.type === "number" ? mixin.methods.convertNumber(value) : value;
    return value + postfix;
  }, []);
  return (
    <div
      className={`cell ${column.type === "status-cell" ? "cell-status" : ""}`}
    >
      {column.type === "status-cell" && (
        <span className={`cell-status-dot dot-${row.status}`}></span>
      )}
      <span
        className={`cell-text ${column.hover ? "cell-text_with-hover" : ""}`}
      >
        {value}
      </span>
    </div>
  );
};

export default StringCell;
